module.exports = __webpack_public_path__ + "static/scholar-4499d036090980b8401b02728183e580.png";